import React, { FC, useState } from 'react';
import { Title } from '../developers/page-components/Title';
import { Dropdown } from 'rsuite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faXmark, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { IModalWindow, ModalWindow } from '../modal/ModalWindow';
import { SecurityAppForm } from './forms/SecurityAppForm';
import { VerificationCodeForm } from './forms/VerificationCodeForm';
import { ButtonComponent } from '../ButtonComponent';
import {
	fetchSecurityInformation,
	removeTwoFactorAuthentication,
	setTwoFactorAuthentication,
	verifyCodeAuthentication
} from '../../store/identyti/actions/security';
import { useIdentity } from '../../store/identyti/identity-context';
import { ButtonLoading } from '../ButtonLoading';
import { useTranslation } from 'react-i18next';
import { LinkComponent } from '../LinkComponent';
import { Spinner } from '../Spinner';
// import { BackUpModal } from './forms/BackUpModal';

export enum AUTHENTICATION_KEYS {
	APP = 'Use an authentication App',
	SMS = 'Add SMS'
}

const authenticationKeyItems = [
	AUTHENTICATION_KEYS.APP,
	// AUTHENTICATION_KEYS.SMS
];

export interface ITwoFactorAuthParams {
	twoFactorEnabled: boolean,
	isUpdate: boolean,
	token: string,
	email: string,
}

export interface IVerificationParams {
	code: string,
	token: string,
	email: string,
}

export const AccountSecurityAddKey: FC = () => {
	// const [authenticationKey, setAuthenticationKey] = useState<AUTHENTICATION_KEYS | string>('');
	const email = localStorage.getItem('userEmail');
	const token = localStorage.getItem('accessToken');
	const { t } = useTranslation();

	// const [number, setNumber] = useState<string>('');
	// const [isNumberModalOpen, setIsNumberModalOpen] = useState<boolean>(false);
	const [isCodeModalOpen, setIsCodeModalOpen] = useState<boolean>(false);
	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});
	const {
		identityState: {
			securityData,
			isTwoFactorEnableLoading,
			isCodeVerificationLoading,
			isRemovingTwoFactorAuthLoading
		},
		dispatch } = useIdentity();
	const { twoFactorEnabled } = securityData;

	const closeModal = (): void => setModalState(prev => ({ ...prev, isOpen: false }));

	// const getAuthenticationType = (): JSX.Element => {
	//
	// 	const additionalText = (
	// 		<div className="text-muted fs-7">
	// 			If you lose you mobile device or security key, you can{' '}
	// 			<span
	// 				className="text-primary cursor-pointer"
	// 				// onClick={openBackUpModal}
	// 			>
	// 				generate a backup code
	// 			</span>{' '}
	// 			to sign in to your account.
	// 		</div>
	// 	);
	//
	// 	switch (authenticationKey) {
	// 		case AUTHENTICATION_KEYS.APP:
	// 			return (
	// 				<>
	// 					{/*TODO ADD 'border-bottom' class when we have Backup code*/}
	// 					<div className="border-top my-5 py-3 d-flex justify-content-between align-items-center">
	// 						<div className="fw-bolder fs-6">Authentication App</div>
	// 						{/*<div className="text-primary">*/}
	// 						{/*	<span*/}
	// 						{/*		className="fs-6 fw-bolder me-2 cursor-pointer"*/}
	// 						{/*		onClick={openQRCodeModal}*/}
	// 						{/*	>*/}
	// 						{/*		Update...*/}
	// 						{/*	</span>*/}
	// 							<FontAwesomeIcon
	// 								icon={faXmark}
	// 								width={16}
	// 								className="text-primary cursor-pointer"
	// 								onClick={(): void => setAuthenticationKey('')}
	// 							/>
	// 						{/*</div>*/}
	// 					</div>
	// 					{/*{additionalText}*/}
	// 				</>
	// 			);
	// 		case AUTHENTICATION_KEYS.SMS:
	// 			return (
	// 				<>
	// 					{/*TODO ADD 'border-bottom' class when we have Backup code*/}
	// 					<div className="border-top my-5 py-3 d-flex justify-content-between align-items-center">
	// 						<div>
	// 							<div className="fw-bolder fs-6">SMS</div>
	// 							<div className="fs-6 mt-2">123</div>
	// 						</div>
	// 						<div className="text-primary">
	// 							{/*<span*/}
	// 							{/*	className="fs-6 fw-bolder me-2 cursor-pointer"*/}
	// 							{/*	onClick={openModalWithMobPhone}*/}
	// 							{/*>*/}
	// 							{/*	Update...*/}
	// 							{/*</span>*/}
	// 							<FontAwesomeIcon
	// 								icon={faXmark}
	// 								width={16}
	// 								className="mt-2 text-primary cursor-pointer"
	// 								onClick={(): void => setAuthenticationKey('')}
	// 							/>
	// 						</div>
	// 					</div>
	// 					{/*{additionalText}*/}
	// 				</>
	// 			);
	// 		default: return <></>;
	// 	}
	// };

	const handleSelect = async (key): Promise<void> => {
		// setAuthenticationKey(key);
		const params: ITwoFactorAuthParams = {
			twoFactorEnabled: true,
			isUpdate: false,
			token,
			email,
		};
		switch (key) {
			case AUTHENTICATION_KEYS.APP: {
				const res = await setTwoFactorAuthentication(dispatch, params);
				const verificationCode = res?.data?.verificationCode;
				const accountName = res?.data?.name;
				return openQRCodeModal(verificationCode, accountName);
			}
			// case AUTHENTICATION_KEYS.SMS:
			// 	openVerificationModal();
			// 	break;
			// default: setIsChangePassModalOpen(true);
			// default: openQRCodeModal();
		}
	};

	const openQRCodeModal = (verificationCode, accountName): void => {
		setModalState({
			isOpen: true,
			modalTitle: 'Use an authenticator app',
			contentClassName: 'd-block',
			backdrop: 'static',
			minHeight: 350,
			onClose: closeModal,
			content: (
				<SecurityAppForm
					accountName={accountName}
					code={verificationCode}
					closeModal={closeModal}
					onConfirm={(): void => {
						closeModal();
						setIsCodeModalOpen(true);
					}}
				/>
			)
		});
	};

	const handleConfirmCode = async (code: string): Promise<void> => {
		const params: IVerificationParams = {
			code,
			token,
			email,
		};
		await verifyCodeAuthentication(dispatch, params, handleSuccessModal, handleErrorModal);
	};

	const handleSuccessModal = (): void => {
		const handleDone = async (): Promise<void> => {
			await fetchSecurityInformation(dispatch, email);
			closeModal();
		};
		setIsCodeModalOpen(false);
		setModalState({
			isOpen: true,
			modalTitle: 'Use an authenticator app',
			contentClassName: 'd-block',
			minHeight: 210,
			backdrop: 'static',
			onClose: handleDone,
			content: (
				<>
					<FontAwesomeIcon icon={faCircleCheck} width={32} className="d-block mx-auto h-32 mt-10"/>
					<div className="fs-6 w-450px mx-auto text-center mt-5">
						From now on, whenever you sign in to your account, you’ll need to enter both your password and also an authentication code generated by Google Authenticator.
					</div>
					<ButtonComponent
						buttonName="Done"
						onButtonClick={handleDone}
						additionalClass="mt-10 d-block mx-auto"
					/>
				</>
			)
		});
	};

	const handleErrorModal = (): void => {
		setIsCodeModalOpen(false);
		setModalState({
			isOpen: true,
			modalTitle: 'Use an authenticator app',
			content: (
				<div>
					<div className="fs-3 text-danger text-center mb-5">
						<FontAwesomeIcon icon={faTriangleExclamation} className="me-1"/>
						Incorrect verification code.
					</div>
					<div className="fs-6 px-15 text-center">
						Having trouble entering your code? Please, contact with {' '}
						<LinkComponent text="administrator." link='mailto:support@flex-charge.com'/>
					</div>

				</div>
			),
			confirmButtonText: t('PARTNERS.FAIL_BTN_NAME'),
			minHeight: 100,
			onConfirm: () => {
				closeModal();
				setIsCodeModalOpen(true);
			},
			onClose: closeModal
		});
	};

	// const openBackUpModal = (): void => {
	// 	setModalState({
	// 		isOpen: true,
	// 		modalTitle: 'Save your backup code',
	// 		contentClassName: 'd-block',
	// 		minHeight: 230,
	// 		backdrop: 'static',
	// 		onClose: closeModal,
	// 		content: <BackUpModal onClose={closeModal}/>
	// 	});
	// };

	const getAdditionalKeySection =
			<div className="border-top my-5 py-3 d-flex justify-content-between align-items-center">
				{
					isRemovingTwoFactorAuthLoading
						? <Spinner/>
						: (
							<>
								<div className="fw-bolder fs-6">Authentication App</div>
								<FontAwesomeIcon
									icon={faXmark}
									width={16}
									className="text-danger cursor-pointer"
									onClick={(): Promise<void> => removeTwoFactorAuthentication(dispatch, email, token)}
								/>
							</>
							)
				}
			</div>;

	return (
		<>
			<div className="w-md-50">
				<Title title="Two-factor authentication" additionalClass="fs-6 fw-bolder mb-3"/>
				<div className="text-muted mb-5">
					Increase security for your account by adding multiple authentication steps.
					You can enable SMS and authentication App
				</div>
				<Dropdown
					title={!isTwoFactorEnableLoading && 'Add authentication key'}
					className="authentication"
					disabled={Boolean(twoFactorEnabled) || isTwoFactorEnableLoading}
					icon={isTwoFactorEnableLoading && <ButtonLoading/>}
				>
					{authenticationKeyItems?.map((key): JSX.Element => (
						<Dropdown.Item
							key={key}
							onClick={(): Promise<void> => handleSelect(key)}
						>
							{key}
						</Dropdown.Item>
					))}
				</Dropdown>

				{twoFactorEnabled && getAdditionalKeySection}

				{/*{getAuthenticationType()}*/}

			</div>

			<ModalWindow
				{...modalState}
				onClose={closeModal}
			/>

			<ModalWindow
				isOpen={isCodeModalOpen}
				modalTitle="Use an authenticator app"
				backdrop="static"
				contentClassName='d-block'
				minHeight={200}
				onClose={(): void => setIsCodeModalOpen(false)}
				content={
					<VerificationCodeForm
						// number={number}
						onBackClick={(): void => setIsCodeModalOpen(false)}
						onContinue={handleConfirmCode}
						isLoading={isCodeVerificationLoading}
					/>
				}
			/>
		</>
	);
};
